import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { error } from './error';
import { GlobalService, IFileUploadResponse, ConfigJsonService,
  IFileDeleteResponse, IFileDeleteRequest, IFileEditRequest,
  IAttachmentHeadersResponse, routePostAttachment, routeGetBlobAttachment,
  routeDeleteAttachment, routeEditAttachment, routeGetAttachmentHeaders, LogService
} from '@medlogic/shared/shared-interfaces';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  private readonly routePostAttachment = `${routePostAttachment}`;
  private readonly routeGetAttachmentHeaders = `${routeGetAttachmentHeaders}`;
  private readonly routeDeleteAttachment = `${routeDeleteAttachment}`;
  private readonly routeEditAttachment = `${routeEditAttachment}`;
  private readonly routeGetBlobAttachment = `${routeGetBlobAttachment}`;

  constructor(
    private log: LogService,
    private glb: GlobalService,
    private cnfJson: ConfigJsonService,
    private http: HttpClient
  ) { }

  /**
   * Save the physical file to the Storage and/or file system.
   * The new API also saves the header at GE database.
   * It uses the node API.
   */
  postFile(fileToUpload: File, ano: number, ono: number, vno: number, containerTag: string = null): Observable<IFileUploadResponse> {
    try {
      const queryParams = `?ano=${ano}&ono=${ono}&vno=${vno}&container_tag=${containerTag}`;
      const urlFileSave = this.glb.urlJoin([this.cnfJson.baseUrlAPI, `${this.routePostAttachment}${queryParams}`]);
      const data = new FormData();
      data.append('file', fileToUpload, fileToUpload.name);

      return this.http.post<IFileUploadResponse>(urlFileSave, data)
        .pipe(
          error()
        );
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'postFile', error.message);
    }
  }

  editFile(fileToUpload: File, editObj: IFileEditRequest): Observable<IFileUploadResponse> {
    try {
      const { dno, ano, ono, vno, filename, container_tag } = editObj;
      const params = new HttpParams()
        .set('dno', dno.toString())
        .set('ano', ano.toString())
        .set('ono', ono.toString())
        .set('vno', vno.toString())
        .set('filename', filename)
        .set('container_tag', container_tag)

      const data = new FormData();
      data.append('file', fileToUpload, fileToUpload.name);

      const urlFileSave = this.glb.urlJoin([this.cnfJson.baseUrlAPI, `${this.routeEditAttachment}`]);
      return this.http.post<IFileUploadResponse>(urlFileSave, data, { params })
        .pipe(
          error()
        );
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'editFile', error.message);
    }
  }

  /** It doesn't get the physical files, but their database reference from the service. */
  getDocumentHeaders(ono: number, tno: number = -1): Observable<IAttachmentHeadersResponse> {
    try {
      tno = tno || -1;
      const queryParams = `?ono=${ono}&tno=${tno}`;
      const urlFileSave = this.glb.urlJoin([this.cnfJson.baseUrlAPI, `${this.routeGetAttachmentHeaders}${queryParams}`]);
      return this.http.get<IFileUploadResponse>(urlFileSave)
        .pipe(
          error()
        );
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'getDocumentHeaders', error.message);
    }
  }

  /**
   * Gets the document name from the original name.
   * @param originalName
   * @returns
   */
  getDocName(originalName: string): string {
    try {
      const idx = originalName.lastIndexOf('_') + 1;
      return originalName.substr(idx);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'getDocName', error.message);
    }
    return null;
  }

  /**
   * Deletes both the header and the actual file at the container.
   * @param deleteObj
   * @returns
   */
  deleteDocument(deleteObj: IFileDeleteRequest): Observable<IFileDeleteResponse> {
    try {
      const { dno, filename, container_tag } = deleteObj;
      const params = new HttpParams()
        .set('dno', dno.toString())
        .set('filename', filename)
        .set('container_tag', container_tag)
      const urlFileSave = this.glb.urlJoin([this.cnfJson.baseUrlAPI, `${this.routeDeleteAttachment}`]);
      return this.http.delete<IFileDeleteResponse>(urlFileSave, { params })
        .pipe(
          error()
        );
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'deleteDocument', error.message);
    }
  }
}
